import { endOfMonth, format, startOfMonth } from "date-fns"

import { SortConfig, TrialBlock } from "../types/trialBlock"

export const sortTrialBlocks = (blocks: TrialBlock[], sortConfig: SortConfig): TrialBlock[] => {
  if (!sortConfig.key) return [...blocks]

  return [...blocks].sort((a, b) => {
    let aValue = a[sortConfig.key as keyof TrialBlock] as string | number
    let bValue = b[sortConfig.key as keyof TrialBlock] as string | number

    if (typeof aValue === "string" && typeof bValue === "string") {
      aValue = aValue.toLowerCase()
      bValue = bValue.toLowerCase()
    }

    if (aValue < bValue) {
      return sortConfig.direction === "ascending" ? -1 : 1
    }
    if (aValue > bValue) {
      return sortConfig.direction === "ascending" ? 1 : -1
    }
    return 0
  })
}

export interface TrialBlockDateRange {
  from: string
  to: string
}

// The calendar shows the whole month around selectedDate, the table only that day.
export const trialBlockDateRange = (
  selectedDate: Date,
  viewMode: "table" | "calendar",
): TrialBlockDateRange => {
  if (viewMode === "table") {
    const day = format(selectedDate, "yyyy-MM-dd")
    return { from: day, to: day }
  }
  return {
    from: format(startOfMonth(selectedDate), "yyyy-MM-dd"),
    to: format(endOfMonth(selectedDate), "yyyy-MM-dd"),
  }
}

export const filterTrialBlocksByDriverName = (
  blocks: TrialBlock[],
  driverNameSearch: string,
): TrialBlock[] => {
  if (!driverNameSearch) return blocks
  const search = driverNameSearch.toLowerCase()
  return blocks.filter((block) => block.driverName.toLowerCase().includes(search))
}
